import React from 'react';
import { graphql } from 'react-relay';
import classes from './OfferHistory.module.scss';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import clsx from 'clsx';
import {
  OfferHistory_offerHistory$data,
  OfferHistory_offerHistory$key,
} from './__generated__/OfferHistory_offerHistory.graphql';

import OfferHistoryItem from './OfferHistoryItem';
import useLiveFragment from '../../../relay/useLiveFragment';
import { CASHBACK } from '../../pages/pages';
import Txt from '../../atoms/Txt/Txt';
import A from '../../atoms/A/A';
import Notice from '../../atoms/Notice/Notice';

export interface Props {
  offerHistoryRef: OfferHistory_offerHistory$key;
  className?: string;
}

const fragmentSpec = graphql`
  fragment OfferHistory_offerHistory on OfferStatusConnection
  @refetchable(queryName: "OfferStatusRefetchQuery") {
    edges {
      node {
        guid
        ...OfferHistoryItem_offer
      }
    }
  }
`;

const OfferHistory: React.FC<Props> = ({ offerHistoryRef, className }) => {
  const offerHistory: OfferHistory_offerHistory$data = useLiveFragment(
    fragmentSpec,
    offerHistoryRef,
  );

  dayjs.extend(calendar);

  return (
    <section className={clsx(classes.transactionListContainer, className)}>
      <Txt component="h2">Offer History</Txt>
      <Notice status={'warning'} className={classes.warning}>
        <Txt>
          When the offer provider notifies us that a cashback offer has been started, it will show
          up here as &apos;Pending&apos;. This usually happens within 2 weeks.
        </Txt>
      </Notice>
      {offerHistory?.edges.length > 0 ? (
        <table className={classes.table}>
          <tbody>
            {offerHistory.edges.map((edge) => (
              <OfferHistoryItem key={edge.node.guid} offerRef={edge.node} />
            ))}
          </tbody>
        </table>
      ) : (
        <Txt component="p">
          Your recent cashback offers will appear here. Check out some{' '}
          <Txt component={A} to={CASHBACK.path}>
            cashback offers{' '}
          </Txt>
          now to get started!
        </Txt>
      )}
    </section>
  );
};

export default OfferHistory;
